var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "captuerWrap"
  }, [_c('Loading', {
    staticClass: "loading",
    attrs: {
      "type": "fixed",
      "visible": true
    }
  }, [_c('p', {
    staticClass: "loadingText"
  }, [_vm._v("PDF 파일을 생성 중 입니다.")])]), _c('WikiViewer', {
    ref: "wikiViwer",
    attrs: {
      "wikiIndex": false,
      "Data": _vm.viewData
    },
    on: {
      "load-content": _vm.loadMounted
    }
  }), _c('pdf-wiki', {
    ref: "pdfWiki",
    attrs: {
      "contentImages": _vm.images
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }